import * as Yup from 'yup';

export const EXCEPTION_ACTIONS = [
  'discount',
  'delete',
  'drawer_open',
  'void',
  'below_cost',
  'refund',
  'edit',
  'return',
] as const;

export const ACTION_LABELS: Record<string, string> = {
  discount: 'Discount',
  delete: 'Delete',
  drawer_open: 'Drawer Open',
  void: 'Void',
  below_cost: 'Below Cost',
  refund: 'Refund',
  edit: 'Edit',
  return: 'Deposit Return',
};

export const ExceptionLogSchema = Yup.object().shape({
  timestamp: Yup.date().required(),
  close_num: Yup.string().defined(),
  initials: Yup.string().defined(),
  code_num: Yup.string().defined(),
  brand: Yup.string().defined(),
  old_price: Yup.number().defined(),
  new_price: Yup.number().defined(),
  quantity: Yup.number().defined(),
  action: Yup.string().defined(),
  barcode: Yup.string().defined(),
  station: Yup.string().defined(),
  invoice_number: Yup.number().defined(),
});

export type ExceptionLog = Yup.InferType<typeof ExceptionLogSchema>;
